import ItemsDemo from "./ItemsDemo";
import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ScrollProgress from "./components/ScrollProgress";
import HomePage from "./pages/HomePage";
import WebsiteServicesPage from "./pages/WebsiteServicesPage";
import CryptoServicesPage from "./pages/CryptoServicesPage";
import DesignServicesPage from "./pages/DesignServicesPage";
import PortfolioPage from "./pages/PortfolioPage";
import ContactPage from "./pages/ContactPage";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <ScrollProgress />
          <Header />
          <main className="min-h-screen pt-20">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/website-hizmetleri" element={<WebsiteServicesPage />} />
              <Route path="/kripto-hizmetleri" element={<CryptoServicesPage />} />
              <Route path="/tasarim-hizmetleri" element={<DesignServicesPage />} />
              <Route path="/portfolyo" element={<PortfolioPage />} />
              <Route path="/iletisim" element={<ContactPage />} />
              <Route path="/demo" element={<ItemsDemo />} />
            </Routes>
          </main>
          <WhatsAppButton />
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;